import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime, Subject } from 'rxjs';
import { Email } from 'src/app/features/login/login';

import { BaseResponse } from 'src/app/model/response/base-response';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LoginService } from '../login.service';

@Component({
    selector: 'app-reset',
    templateUrl: './resetpassword.component.html',
    styleUrls: ['../login.component.scss', './resetpassword.component.scss'],
    providers: [DatePipe],
    standalone: false
})

export class ResetPasswordComponent implements OnInit {
  // create strict typed angular form, preaty neat
  formReset = new FormGroup({
    email: new FormControl<string>('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.minLength(1),
    ]),
  });

  formHaveErrors: boolean = false;
  errMsg: string = '';
  rispReset!: BaseResponse;

  //subjects for displaying errors while writing data on the form
  private mailValidSubject$: Subject<string> = new Subject<string>();

  //needed for form validation on signup method call
  public patternMail: RegExp = new RegExp('^[^@]+@[^@]+$');
  public mailNotValid: boolean = false;
  public mailExists: boolean = false;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private datePipe: DatePipe,
    private localStorageS:LocalStorageService,
  ) {}

  ngOnInit(): void {

    //needed for displaying real time errors on form
    this.mailValidSubject$.pipe(debounceTime(800)).subscribe({
      next: (value: string) => {
        let a = this.patternMail.test(value);
        console.log(a);
        if (this.patternMail.test(value)) {
          this.mailNotValid = false;
        } else {
          this.mailNotValid = true;
        }
      },
    });

  }

  mailValidation(mail: string) {
    this.mailValidSubject$.next(mail)
  }

  otp(){
    if(this.formReset.invalid){
      this.errMsg = 'Compila tutti i campi';
      this.formHaveErrors = true;
      console.error(
        'Errors in form validation, check the inserted data and try again'
      );
      return;
    }

    let mail = this.formReset.value.email || '';

    if(mail==''){
      this.errMsg= "inserisci una mail";
      this.formHaveErrors = true;
    }

    //this.localStorageS.setMail(mail);

    let email: Email = {
      email: mail
    }

    this.loginService.sendOtp(email).subscribe({
      next:(response:BaseResponse)=>{
        console.log(response)
        if(response.success==true){
          this.router.navigate(['/login/otp/reset']); //change with mail
        }
      },
      error:(response:BaseResponse)=>{
        //this.localStorageS.removeMail();
        console.error('Error while processing');
        console.error(response);
        this.formHaveErrors = true;
        this.errMsg = response.error;
      }
    });


  }


}


